<div style="height: 100%; display: flex; flex-direction: column;"> 
    <!-- Chart container with explicit flex sizing -->
    <div style="flex: 0 0 48%; width: 100%; overflow: hidden; position: relative;">
        <canvas baseChart 
                type="bar"
                [data]="failureChartData"
                [options]="failureChartOptions"
                >
        </canvas>
    </div>
    
    <!-- Spacer -->
    <div style="flex: 0 0 2%; min-height: 10px;"></div>
    
    <!-- Table container with explicit flex sizing -->
    <div style="flex: 0 0 48%; overflow: hidden;">
        <p-table #dt [value]="filteredTableData" 
                 scrollable="true" 
                 scrollHeight="flex"
                 [exportFilename]="'failure-reasons'"
                 [columns]="cols"
                 dataKey="date_time">
            <ng-template pTemplate="caption">
                <div style="display: flex; align-items: center; justify-content: space-between;">
                 
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th style="width:200px;">{{ 'maintenanceFailureReasons.table.dateTime' | transloco }}</th>
                    <th style="min-width:100px;">{{ 'maintenanceFailureReasons.table.failureReason' | transloco }}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData>
                <tr>
                    <td>{{ rowData.date_time }}</td>
                    <td >{{ rowData.reason }}</td>
                </tr>
            </ng-template>
        </p-table>
    </div> 
</div>

